import { MES_STAGE_MAP } from "../../../script/enum";
export function evalFilter(fDesc, valObj) {
    /* if (fDesc && fDesc.trg) {
        console.log(fDesc.type, fDesc.trg, valObj.list[fDesc.trg.atr]);
    } */
    if (fDesc.type == "filter_and") {
        for (let i = 0; i < fDesc.sub.length; i++) {
            if (!evalFilter(fDesc.sub[i], valObj)) {
                return false;
            }
        }
        return true;
    }
    else if (fDesc.type == "filter_or") {
        for (let i = 0; i < fDesc.sub.length; i++) {
            if (evalFilter(fDesc.sub[i], valObj)) {
                return true;
            }
        }
        return false;
    }
    else if (fDesc.type == "filter_val") {
        if (!fDesc.trg ||
            fDesc.trg.atr < 0 ||
            fDesc.trg.atr >= valObj.list.length) {
            return true;
        }
        const op = fDesc.trg.operaion;
        const ty = valObj.list[fDesc.trg.atr].type;
        const valTrg = fDesc.trg.val;
        const valCur = valObj.list[fDesc.trg.atr].val;
        // console.log("c", op, ty, valTrg, valCur)
        if ((op == "eq" || op == "noteq") &&
            (ty == "title" || ty == "string")) {
            // TODO is date ok?
            const ret = typeof valTrg === 'string' && typeof valCur === 'string' ? valTrg.toLowerCase() == valCur.toLowerCase() : false;
            return op == "eq" ? ret : !ret;
        }
        else if ((op == "eq" || op == "noteq") && ty == "number") {
            const ret = valTrg === valCur;
            return op == "eq" ? ret : !ret;
        }
        else if ((op == "eq" || op == "noteq") && (ty == "time")) {
            const t1 = new Date(valTrg).getTime();
            const t2 = new Date(valCur).getTime();
            if (isNaN(t1) || isNaN(t2)) {
                return false;
            }
            return t1 === t2; // TODO
        }
        else if ((op == "more" || op == "less") && ty == "number") {
            return op == "more" ? valTrg > valCur : valTrg < valCur;
        }
        else if ((op == "more" || op == "less") && ty == "time") {
            const t1 = new Date(valTrg).getTime();
            const t2 = new Date(valCur).getTime();
            if (isNaN(t1) || isNaN(t2)) {
                return false;
            }
            return op == "more" ? t1 > t2 : t1 < t2;
        }
        else if ((op == "eq" || op == "noteq") && ty == "mesState") {
            const statValTrg = MES_STAGE_MAP[valTrg];
            const statValCur = MES_STAGE_MAP[valCur];
            const ret = statValTrg.sequenceId === statValCur.sequenceId;
            return op == "eq" ? ret : !ret;
        }
        else if ((op == "more" || op == "less") && ty == "mesState") {
            const statValTrg = MES_STAGE_MAP[valTrg];
            const statValCur = MES_STAGE_MAP[valCur];
            return op == "more" ? statValTrg.sequenceId < statValCur.sequenceId : statValTrg.sequenceId > statValCur.sequenceId;
        }
        else if (op == "isEmpty") {
            // TODO is 0 empty ? typeof valTrg === "number"
            return !Boolean(valCur);
        }
        else if (op == "notisEmpty") {
            return Boolean(valCur);
        }
        else if (op == "length" && ty == "tripleCounter") {
            return Array.isArray(valCur) ? valTrg === valCur.length : true;
        }
        else {
            console.warn("Operation-Type pair not found in filter", op, ty, valTrg, valCur);
            return true;
        }
    }
}
export function evalSort(sortList, valObjA, valObjB) {
    if (sortList.length == 0) {
        return 0;
    }
    const fDesc = sortList[0];
    let resRetVal = 0;
    if (fDesc.type == "sort_val") {
        if (!fDesc.trg ||
            fDesc.trg.atr < 0 ||
            fDesc.trg.atr >= valObjA.list.length ||
            fDesc.trg.val === null) {
            resRetVal = 0;
        }
        else {
            const op = fDesc.trg.operaion;
            const ty = valObjA.list[fDesc.trg.atr].type;
            const va = valObjA.list[fDesc.trg.atr].val;
            const vb = valObjB.list[fDesc.trg.atr].val;
            if ((op == "max" || op == "min") &&
                (ty == "title" || ty == "string")) {
                const ret = va.localeCompare(vb);
                resRetVal = op == "max" ? -1 * ret : ret;
            }
            else if ((op == "max" || op == "min") && ty == "number") {
                const ret = va == vb ? 0 : va < vb ? -1 : 1;
                resRetVal = op == "max" ? -1 * ret : ret;
            }
            else if ((op == "max" || op == "min") && ty == "boolean") {
                const ret = va == vb ? 0 : vb ? -1 : 1;
                resRetVal = op == "max" ? -1 * ret : ret;
            }
            else if ((op == "max" || op == "min") && (ty == "date" || ty == "time")) {
                const t1 = new Date(va).getTime();
                const t2 = new Date(vb).getTime();
                if (isNaN(t1) || isNaN(t2)) {
                    resRetVal = 0;
                }
                else {
                    const ret = t1 == t2 ? 0 : t1 < t2 ? -1 : 1;
                    resRetVal = op == "max" ? -1 * ret : ret;
                }
            }
            else if ((op == "max" || op == "min") && ty == "mesState") {
                const statValA = MES_STAGE_MAP[va];
                const statValB = MES_STAGE_MAP[vb];
                const ret = statValA == statValB ? 0 : statValB ? -1 : 1;
                resRetVal = op == "max" ? -1 * ret : ret;
            }
            else if ((op == "max" || op == "min") && ty == "tripleCounter") {
                const statValA = va ? va.length : 0;
                const statValB = vb ? vb.length : 0;
                const ret = statValA == statValB ? 0 : statValB ? -1 : 1;
                resRetVal = op == "max" ? -1 * ret : ret;
            }
            else {
                resRetVal = 0; /* WTF debuger */
                console.warn("Operation-Type pair not found in sort", op, ty, va, vb);
            }
        }
    }
    if (resRetVal == 0) {
        return evalSort(sortList.slice(1), valObjA, valObjB);
    }
    return resRetVal;
}
